module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.8d09c5a3.woff";